import { combineReducers, configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import loginReducer from './login/loginSlice';
import userCredentialReducer from './userCredential/userCredentialSlice'
import deviceReducer from './device/deviceSlice';
import configReducer from './config/configSlice'
import snackbarReducer from './snackbar/snackbarSlice'
import audioDevicesReducer from './audioDevice/audioDeviceSlice'
import backgroundReducer from './background/backgroundSlice'
import callHistoryReducer from './callHistory/callHistorySlice';
import analyticAdminReducer from './analytic/analyticAdminSlice'
import analyticUserDataReducer from './analytic/analyticUserDataSlice'
import analyticTeamDataReducer from './analytic/analyticTeamDataSlice'
import analyticDomainDataReducer from './analytic/analyticDomainDataSlice'
import analyticSubscriptionUsageReducer from './analytic/analyticSubscriptionUsageSlice'
import analyticTeamReducer from './analytic/analyticTeamSlice'
import analyticTeamMemberReducer from './analytic/analyticTeamMemberSlice'
import analyticTeamReportReducer from './analytic/analyticTeamReportSlice'
import assistantQuotaReducer from './assistant/assistantQuotaSlice'
import callRecordingReducer from './callRecording/callRecordingSlice'
import callQueueReducer from './callQueue/callQueueSlice'
import callParkReducer from './callPark/callParkSlice'
import contactReducer from './contact/contactSlice';
import presenceReducer from './presence/presenceSlice';
import messageSessionReducer from './message/messageSessionSlice';
import messageReducer from './message/messageSlice';
import voicemailReducer from './voicemail/voicemailSlice';
import socketReducer from './socket/socketSlice';
import userAgentReducer from './userAgent/userAgentSlice';
import callSessionsReducer from './callSessions/callSessionsSlice'
import activeCallScreenReducer from './activeCallScreen/activeCallScreenSlice';
import feedbackReducer from './feedback/feedbackSlice'
import activeDomainCallReducer from './callCenter/activeDomainCall'
import domainInfoReducer from './callCenter/domainInfoSlice'
import domainCallCountReducer from './callCenter/domainCallCountSlice'
import userCallReportReducer from './callCenter/userCallReportSlice'
import domainCallReportReducer from './callCenter/domainCallReportSlice'
import notificationReducer from './notification/notificationSlice'
import integrationReducer from './integration/integrationSlice';
import singleInstanceReducer from './singleInstance/singleInstanceSlice';

import rootSaga from '../sagas/rootSaga'

const sagaMiddleware = createSagaMiddleware();

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['userCredential', 'device', 'login', 'config'], // Only persist these slice
};

const rootReducer = combineReducers({
  login: loginReducer,
  userCredential: userCredentialReducer,
  audioDevices: audioDevicesReducer,
  background: backgroundReducer,
  device: deviceReducer,
  config: configReducer,
  snackbar: snackbarReducer,
  callHistory: callHistoryReducer,
  analyticAdmin: analyticAdminReducer,
  analyticUserData: analyticUserDataReducer,
  analyticTeamData: analyticTeamDataReducer,
  analyticDomainData: analyticDomainDataReducer,
  analyticSubscriptionUsage: analyticSubscriptionUsageReducer,
  analyticTeam: analyticTeamReducer,
  analyticTeamMember: analyticTeamMemberReducer,
  analyticTeamReport: analyticTeamReportReducer,
  assistantQuota: assistantQuotaReducer,
  callRecording: callRecordingReducer,
  callPark: callParkReducer,
  callQueue: callQueueReducer,
  contact: contactReducer,
  presence: presenceReducer,
  messageSession: messageSessionReducer,
  message: messageReducer,
  voicemail: voicemailReducer,
  feedback: feedbackReducer,
  socket: socketReducer,
  userAgent: userAgentReducer,
  callSessions: callSessionsReducer,
  activeCallScreen: activeCallScreenReducer,
  activeDomainCall: activeDomainCallReducer,
  domainInfo: domainInfoReducer,
  domainCallCount: domainCallCountReducer,
  userCallReport: userCallReportReducer,
  domainCallReport: domainCallReportReducer,
  notification: notificationReducer,
  integration: integrationReducer,
  singleInstance: singleInstanceReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: false,
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export const persistor = persistStore(store);

export default store;
